/**
 * API version required for editing variants queries.
 * Uses the `X` alias while variants are in beta; will move to a dated version when stable.
 *
 * @public
 */
export const variantsApiVersion = 'X'
